
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class OficinaTuristica extends Vue {
  private win = window;
  private base = window.location;
  private left = false;

  private link: any = "https://www.youtube.com/watch?v=ty70iFFIuvw";

  private video() {
    if (this.link && this.link != "") {
      var url = this.link;
      url = url.replace("watch?v=", "embed/");
      return url;
    }
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }
}
